import request from './request.js'

/*
* H5获取协议
* */
export function getAgreement(data) {
  let url = '/account/system/text/get/one'
  return request.post(url, data);
}